import { render, staticRenderFns } from "./AlertSettingUpload.vue?vue&type=template&id=5b571c50&scoped=true"
import script from "./AlertSettingUpload.vue?vue&type=script&lang=js"
export * from "./AlertSettingUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b571c50",
  null
  
)

export default component.exports